import React from 'react';

import Footer from 'react-bulma-companion/lib/Footer';
import Container from 'react-bulma-companion/lib/Container';
import Content from 'react-bulma-companion/lib/Content';

export default function FooterComponent() {
  const year = new Date().getFullYear();

  return (
    <Footer>
      <Container>
        <Content className="has-text-centered">
          <p>
            {`Copyright Ⓒ ${year} Abramson Labor Group. All Rights Reserved.`}
          </p>
          <p>
            <a href="https://abramsonlaborgroup.com/terms-and-conditions/" target="_blank">Terms & Conditions</a> | <a href="https://abramsonlaborgroup.com/privacy-policy/" target="_blank">Privacy Policy</a>
          </p>
        </Content>
      </Container>
    </Footer>
  );
}
